export default __webpack_public_path__ + "static/media/IMG-20241210-WA0040.76dec7d8.jpg";